import { postAPI, fetchAuthAPI, putAuthAPI, deleteAuthAPI } from './client';

export interface ContactRequest {
  name: string;
  email: string;
  phone?: string;
  subject?: string;
  message: string;
}

export interface ContactInquiry {
  id: number;
  name: string;
  email: string;
  phone?: string;
  subject?: string;
  message: string;
  status: 'NEW' | 'IN_PROGRESS' | 'COMPLETED';
  adminNote?: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * Submit a new contact inquiry (Public API)
 */
export const submitContactInquiry = async (request: ContactRequest): Promise<any> => {
  return postAPI('/contact/submit', request);
};

/**
 * Get all contact inquiries (Admin only)
 */
export const getAllInquiries = async (token: string): Promise<ContactInquiry[]> => {
  return fetchAuthAPI<ContactInquiry[]>('/contact/inquiries');
};

/**
 * Get inquiries by status (Admin only)
 */
export const getInquiriesByStatus = async (
  status: 'NEW' | 'IN_PROGRESS' | 'COMPLETED',
  token: string
): Promise<ContactInquiry[]> => {
  return fetchAuthAPI<ContactInquiry[]>(`/contact/inquiries/status/${status}`);
};

/**
 * Update inquiry status (Admin only)
 */
export const updateInquiryStatus = async (
  id: number,
  status: 'NEW' | 'IN_PROGRESS' | 'COMPLETED',
  adminNote: string,
  token: string
): Promise<ContactInquiry> => {
  return putAuthAPI<ContactInquiry>(`/contact/inquiries/${id}/status`, { status, adminNote });
};

/**
 * Delete inquiry (Admin only)
 */
export const deleteInquiry = async (id: number, token: string): Promise<void> => {
  return deleteAuthAPI<void>(`/contact/inquiries/${id}`);
};
